import { render, staticRenderFns } from "./Mis_BoletasPrincipal.vue?vue&type=template&id=4707a5b0&scoped=true&"
import script from "./Mis_BoletasPrincipal.vue?vue&type=script&lang=js&"
export * from "./Mis_BoletasPrincipal.vue?vue&type=script&lang=js&"
import style0 from "./Mis_BoletasPrincipal.vue?vue&type=style&index=0&id=4707a5b0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4707a5b0",
  null
  
)

export default component.exports